export default __webpack_public_path__ + "static/media/main-background.d131a84d.png";